import { useEffect } from "react";

export default function FullscreenModal({ title, children, onPrev, onNext, onClose }) {
  // Escape closes the modal.
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-[9999] bg-black/60 backdrop-blur-sm flex">
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="fullscreen-modal-title"
        className="w-full h-full bg-white dark:bg-[oklch(0.225_0.026_264)] rounded-none shadow-xl flex flex-col overflow-hidden"
      >
        <div className="px-5 py-3 bg-gray-50 dark:bg-[oklch(0.26_0.028_264/0.6)] border-b dark:border-[oklch(0.33_0.022_264)] flex items-center justify-between">
          <div id="fullscreen-modal-title" className="font-semibold text-gray-800 dark:text-slate-100">{title}</div>
          <div className="flex items-center gap-2 text-black dark:text-slate-100">
            <button
              onClick={onPrev}
              className="px-3 py-1.5 rounded border dark:border-[oklch(0.33_0.022_264)] hover:bg-gray-100 dark:hover:bg-[oklch(0.26_0.028_264)]"
              aria-label="Previous"
            >
              ← Prev
            </button>
            <button
              onClick={onNext}
              className="px-3 py-1.5 rounded border dark:border-[oklch(0.33_0.022_264)] hover:bg-gray-100 dark:hover:bg-[oklch(0.26_0.028_264)]"
              aria-label="Next"
            >
              Next →
            </button>
            <button
              onClick={onClose}
              className="ml-2 px-3 py-1.5 rounded bg-gray-800 dark:bg-[oklch(0.3_0.024_264)] text-white hover:bg-gray-700 dark:hover:bg-[oklch(0.38_0.022_264)]"
              aria-label="Close"
            >
              Close
            </button>
          </div>
        </div>
        <div className="flex-1 overflow-auto p-5 bg-white dark:bg-[oklch(0.225_0.026_264)]">{children}</div>
      </div>
    </div>
  );
}
